import Vue from 'vue'
import { API_URL } from '../../api'
import InvestorsFilter from '../../filters/InvestorsFilter';
const state = {
    investorCreate: {
        createdInvestor: null,
        creatingInvestor: false,
        createInvestorStatus: null
    },
    investorUpdate: {
        updatedInvestor: null,
        updatingInvestor: false,
        updateInvestorStatus: null
    },
    investorDelete: {
        deletingInvestor: false,
        deleteInvestorStatus: null
    },
    investorSearch: {
        investorsCount: null,
        investors: [],
        searchingInvestors: false,
        searchInvestorStatus: null
    },
}
const mutations = {
    ['SET_INVESTOR_CREATE'](state, change) {
        state.investorCreate = { ...state.investorCreate, ...change };
    },
    ['SET_INVESTOR_UPDATE'](state, change) {
        state.investorUpdate = { ...state.investorUpdate, ...change };
    },
    ['SET_INVESTOR_DELETE'](state, change) {
        state.investorDelete = { ...state.investorDelete, ...change };
    },
    ['SET_INVESTOR_SEARCH'](state, change) {
        state.investorSearch = { ...state.investorSearch, ...change };
    }
}
const actions = {
    createInvestor: ({ commit }, payload) => {
        commit('SET_INVESTOR_CREATE', { createInvestorStatus: null, createdInvestor: null, creatingInvestor: true })
        return Vue.http.post(API_URL + '/investors/create', payload).then(response => {
            commit('SET_INVESTOR_CREATE', { createInvestorStatus: 'success', createdInvestor: response.body.results.investor });
        }).catch(response => {
            commit('SET_INVESTOR_CREATE', { createInvestorStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_CREATE', { creatingInvestor: false });
        });
    },
    updateInvestor: ({ commit }, payload) => {
        commit('SET_INVESTOR_UPDATE', { updateInvestorStatus: null, updatedInvestor: null, updatingInvestor: true })
        return Vue.http.post(API_URL + '/investors/update/' + payload.id, payload)
            .then(response => {
                commit('SET_INVESTOR_UPDATE', { updateInvestorStatus: 'success', updatedInvestor: response.body.results.investor });
            })
            .catch(response => {
                commit('SET_INVESTOR_UPDATE', { updateInvestorStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_INVESTOR_UPDATE', { updatingInvestor: false });
            })
    },
    deleteInvestor: ({ commit }, id) => {
        commit('SET_INVESTOR_DELETE', { deleteInvestorStatus: null, deletedInvestor: null, deletingInvestor: true })
        return Vue.http.delete(API_URL + '/investors/delete/' + id).then(response => {
            commit('SET_INVESTOR_DELETE', { deleteInvestorStatus: 'success' });
        }).catch(response => {
            commit('SET_INVESTOR_DELETE', { deleteInvestorStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_DELETE', { deletingInvestor: false });
        })
    },
    searchInvestors: ({ commit }, payload = { filter: InvestorsFilter(), resultMode: 'default' }) => {
        commit('SET_INVESTOR_SEARCH', { searchInvestorStatus: null, searchInvestor: null, searchingInvestors: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/investors' + params).then(response => {
            commit('SET_INVESTOR_SEARCH', { searchInvestorStatus: 'success', investors: response.body.results.investors });
        }).catch(response => {
            commit('SET_INVESTOR_SEARCH', { searchInvestorStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_SEARCH', { searchingInvestors: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/investorStore.js